import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminContentPlan from "@/pages/admin/AdminContentPlan";

export const Route = createFileRoute("/admin/content-plan")({
  head: () => ({ meta: [{ title: "Content Plan | Admin" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => (
    <ProtectedRoute>
      <AdminContentPlan />
    </ProtectedRoute>
  ),
});
